module.exports = "pegasus_template/assets/styleGroup1-pinterest.png";